import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ProjectArticle from "../components/projects/ProjectArticle";
import ProjectGrid from "../components/projects/ProjectGrid";
import PageMeta from "../components/seo/PageMeta";
import { getProjectById, PROJECTS } from "../data/projects";
import {
  buildBreadcrumbJsonLd,
  buildCreativeWorkJsonLd,
  buildWebPageJsonLd,
} from "../lib/seo";
import "../styles/projects.css";

function ProjectsComingSoonOverlay() {
  return (
    <div className="projects-coming-soon-shell__overlay" role="status" aria-live="polite">
      <p className="projects-coming-soon-shell__heading">COMING SOON</p>
      <p className="projects-coming-soon-shell__note">
        Sorry, not enough time during the day but I am working on this.
      </p>
    </div>
  );
}

function ProjectsComingSoonShell({ children }) {
  return (
    <div className="projects-coming-soon-shell">
      {children}
      <ProjectsComingSoonOverlay />
    </div>
  );
}

export default function ProjectsPage() {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const project = projectId ? getProjectById(projectId) : null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [projectId]);

  useEffect(() => {
    if (projectId && !project) {
      navigate("/projects", { replace: true });
    }
  }, [projectId, project, navigate]);

  const openProject = (id) => {
    navigate(`/projects/${id}`);
  };

  const backToGrid = () => {
    navigate("/projects");
  };

  if (project) {
    const path = `/projects/${project.id}`;

    return (
      <ProjectsComingSoonShell>
        <PageMeta
          title={project.title}
          description={project.dek}
          path={path}
          image={project.img}
          section={project.cat}
          keywords={[project.cat, project.title, "photo project", "CJ Jayamaha"]}
          jsonLd={[
            buildWebPageJsonLd({
              title: project.title,
              description: project.dek,
              path,
              image: project.img,
            }),
            buildCreativeWorkJsonLd({
              title: project.title,
              description: project.dek,
              path,
              image: project.img,
              genre: project.cat,
            }),
            buildBreadcrumbJsonLd([
              { name: "Home", path: "/" },
              { name: "Projects", path: "/projects" },
              { name: project.title, path },
            ]),
          ]}
        />
        <ProjectArticle project={project} onBack={backToGrid} onOpen={openProject} />
      </ProjectsComingSoonShell>
    );
  }

  return (
    <ProjectsComingSoonShell>
      <PageMeta
        title="Projects"
        description="Multi-year photography projects by CJ Jayamaha — conservation, motorsport, wildlife, landscape, and documentary bodies of work."
        path="/projects"
        image={PROJECTS[0]?.img || "rhino-hero.jpg"}
        keywords={["photography projects", "conservation", "motorsport", "documentary", "CJ Jayamaha"]}
        jsonLd={buildWebPageJsonLd({
          title: "Photography Projects",
          description:
            "Long-form photography projects by CJ Jayamaha across conservation, motorsport, wildlife, and documentary work.",
          path: "/projects",
          image: PROJECTS[0]?.img || "rhino-hero.jpg",
        })}
      />
      <ProjectGrid onOpen={openProject} />
    </ProjectsComingSoonShell>
  );
}
